import { CmsDirectDebitInstructionConfirmation } from '../../models/cms/cms-direct-debit-instruction-confirmation.interface';

export const mockCmsDirectDebitInstructionConfirmation: CmsDirectDebitInstructionConfirmation =
  {
    directDebitInstructionConfirmationTitle:
      'Confirmation of Direct Debit instruction',
    directDebitInstructionConfirmationBody:
      'Please pay Domestic & General Services Limited direct debits from the account detailed in the instruction subject to safeguards assured by the Direct Debit Guarantee. I understand this instruction may remain with Domestic & General Services Limited and, if so, details will be passed electronically to my bank/building society.',
  };
